import React from 'react';
import { createUseStyles } from 'react-jss';
import Divider from '../Divider';

// style =====================================

const useStyles = createUseStyles({
  title: {
    display: 'flex',
    margin: 0,
    padding: '11px 15px',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '18px',
    textTransform: 'uppercase',
    color: '#282C37',
  },
});

type Props = {
  children: React.ReactNode;
};

export const SegmentTitle = (props: Props) => {
  const { children } = props;
  const classes = useStyles();

  return (
    <div>
      <div className={classes.title}>{children}</div>
      <Divider />
    </div>
  );
};

export default SegmentTitle;
